// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Avis acheteur -> prestataire : carte (lecture seule) + editeur (onglet commande). */

.avis-eval {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}
.avis-eval-notice { margin: 0 0 1.2rem; }
.avis-eval-empty {
  font-size: 1.4rem;
  color: #9ca3af;
  text-align: center;
  padding: 3rem 0;
}
/* Carte unique de l'avis (onglet Evaluation commande), meme look que les cartes du profil. */
.avis-eval-card {
  padding: 1.2rem 1.4rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
}
.avis-eval-card-note { display: inline-flex; align-items: center; }

/* ── Highlight de la section d'avis a remplir (carte editable) ; l'autre carte est attenuee. ── */
.avis-eval-card--actionable {
  background: rgba(249, 115, 22, 0.06);
  border-left: 4px solid #f97316;
}
.avis-eval-card--given {
  border-left: 4px solid #22c55e;
}
/* Etoiles vides en orange leger dans la carte a remplir, pour attirer l'oeil. */
.avis-eval-card--actionable .star-rating-btn .star-rating-glyph:not(.is-filled) {
  fill: rgba(249, 115, 22, 0.32);
}
/* Pastille "Votre avis" en tete de la carte editable. */
.avis-eval-badge {
  display: inline-block;
  font-size: 1.15rem;
  font-weight: 700;
  padding: 0.25rem 0.85rem;
  border-radius: 999px;
  margin-bottom: 1rem;
}
.avis-eval-badge--todo {
  background: rgba(249, 115, 22, 0.14);
  color: #ea580c;
}
.avis-eval-badge--done {
  background: rgba(34, 197, 94, 0.14);
  color: #15803d;
}
.avis-ligne-date { color: #9ca3af; }
/* En-tete de la carte d'avis : nom de la contrepartie + lot technique / lot geo / panier. */
.avis-eval-head {
  margin-bottom: 1rem;
  padding-bottom: 0.9rem;
  border-bottom: 1px solid #e5e7eb;
}
.avis-eval-name {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
}

/* Carte d'avis. */
.avis-card {
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  padding: 1.6rem 1.8rem;
  background: #fff;
}
.avis-card + .avis-card { margin-top: 1.2rem; }

.avis-card-head {
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
}
.avis-card-logo {
  flex-shrink: 0;
  width: 5.4rem;
  height: 5.4rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #9ca3af;
  background: #f9fafb;
  overflow: hidden;
  text-align: center;
}
.avis-card-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.avis-card-id { min-width: 0; flex: 1 1; }
.avis-card-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
}
.avis-card-num {
  font-size: 1.25rem;
  font-weight: 600;
  color: #6b7280;
  margin-top: 0.1rem;
}
.avis-card-meta {
  font-size: 1.2rem;
  color: #9ca3af;
  margin-top: 0.1rem;
}
.avis-card-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  font-size: 1.2rem;
  color: #6b7280;
}
.avis-card-note { font-weight: 700; color: #374151; }
.avis-card-date { color: #9ca3af; }

.avis-card-comment {
  margin: 1rem 0 0;
  font-size: 1.35rem;
  color: #374151;
  line-height: 1.5;
  font-style: italic;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Editeur (acheteur sur la commande). */
.avis-card--edit { background: #fff; }
.avis-eval-textarea {
  width: 100%;
  margin-top: 1.2rem;
  min-height: 9rem;
  padding: 1rem 1.2rem;
  border: 1px solid #d1d5db;
  border-radius: 0.7rem;
  font-size: 1.35rem;
  font-family: inherit;
  color: #374151;
  resize: vertical;
}
.avis-eval-textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}
.avis-eval-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.6rem;
  font-size: 1.2rem;
  color: #9ca3af;
}
.avis-eval-status { color: #16a34a; font-weight: 600; }

/* Indicateur d'enregistrement (texte simple) : gris au repos, orange pendant (frappe/envoi),
   vert une fois "enregistre". */
.avis-eval-save { font-size: 1.2rem; font-weight: 600; color: #9ca3af; }
.avis-eval-save--pending,
.avis-eval-save--saving { color: #f97316; }
.avis-eval-save--saved { color: #16a34a; }

/* Bloc de notation editable : libelle + etoiles + valeur chiffree + aide (etoiles cliquables). */
.avis-eval-rate { margin-top: 1.4rem; }
.avis-eval-rate-label {
  display: block;
  font-size: 1.3rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 0.5rem;
}
.avis-eval-rate-stars { display: inline-flex; align-items: center; gap: 0.9rem; }
.avis-eval-rate-val { font-size: 1.6rem; font-weight: 700; color: #374151; }
.avis-eval-rate-hint {
  display: block;
  margin-top: 0.5rem;
  font-size: 1.2rem;
  font-style: italic;
  color: #9ca3af;
}
/* Barre d'actions de la carte (impression PDF) alignee a droite. */
.avis-eval-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.4rem;
  padding-top: 1.2rem;
  border-top: 1px solid #e5e7eb;
}

/* Skeleton de chargement (carte grisee animee). */
.avis-card--skeleton {
  height: 13rem;
  background: linear-gradient(90deg, #f3f4f6 25%, #f9fafb 50%, #f3f4f6 75%);
  background-size: 200% 100%;
  animation: avis-card-sk 1.4s ease-in-out infinite;
}
@keyframes avis-card-sk {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* ── Avis GROUPES (par prestataire ou acheteur) : accordeon compact ── */
.avis-groupes { display: flex; flex-direction: column; gap: 0.8rem; }

/* Barre de recherche / filtre des avis (onglet Evaluations). */
.avis-search-bar {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 0.4rem;
}
.avis-search-input {
  flex: 1 1 22rem;
  min-width: 16rem;
  padding: 0.8rem 1.1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.7rem;
  font-size: 1.35rem;
  font-family: inherit;
  color: #374151;
}
.avis-search-input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}
.avis-filter-select {
  padding: 0.8rem 1.1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.7rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #374151;
  background: #fff;
  cursor: pointer;
  max-width: 24rem;
}
.avis-filter-select:focus { outline: none; border-color: #f97316; }
.avis-search-count { font-size: 1.25rem; color: #6b7280; white-space: nowrap; }
/* Note globale (moyenne de tous les avis) en entete. */
.avis-groupes-entete {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.4rem;
  font-size: 1.4rem;
  color: #374151;
}
.avis-groupes-moyenne { font-weight: 700; }
.avis-groupes-total { color: #6b7280; }
.avis-groupe {
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  overflow: hidden;
  background: #fff;
}
/* Grille alignee : logo | nom (1fr) | compteur (auto) | note (14rem) | chevron (2.2rem).
   Memes colonnes que les lignes depliees -> etoiles + note alignees verticalement, sans chevauchement. */
.avis-groupe-head {
  width: 100%;
  display: grid;
  grid-template-columns: 3.6rem 1fr auto 14rem 2.2rem;
  align-items: center;
  gap: 1rem;
  padding: 0.9rem 1.2rem;
  background: #fff;
  border: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
}
.avis-groupe-head:hover { background: #f9fafb; }
.avis-groupe-logo {
  flex-shrink: 0;
  width: 3.6rem;
  height: 3.6rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f9fafb;
}
.avis-groupe-logo img { width: 100%; height: 100%; object-fit: contain; }
.avis-groupe-logo-txt { font-size: 1.1rem; font-weight: 700; color: #9ca3af; }
.avis-groupe-nom {
  min-width: 0;
  font-size: 1.45rem;
  font-weight: 700;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Colonne note 14rem (etoiles 5x2rem + valeur), etoiles a gauche -> alignement vertical. */
.avis-groupe-note {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.25rem;
  color: #6b7280;
  white-space: nowrap;
}
.avis-groupe-note-val { font-weight: 700; color: #374151; }
.avis-groupe-count {
  justify-self: end;
  white-space: nowrap;
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  padding: 0.2rem 0.7rem;
  border-radius: 999px;
}
.avis-groupe-chevron { color: #9ca3af; transition: transform 0.2s ease; }
.avis-groupe.is-open .avis-groupe-chevron { transform: rotate(180deg); }
.avis-groupe-body {
  padding: 1rem 1.2rem 1.2rem;
  border-top: 1px solid #f3f4f6;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
/* Ligne depliee : MEMES colonnes que l'en-tete (spacer logo | contenu 1fr | note 14rem | chevron 2.2rem)
   -> la note de chaque commande s'aligne pile sous la note globale du prestataire. Bordure grise simple. */
.avis-ligne {
  display: grid;
  grid-template-columns: 1fr 14rem 2.2rem;
  align-items: start;
  gap: 1rem;
  padding: 1rem 1.2rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.6rem;
}
.avis-ligne-main { min-width: 0; }
/* En-tete d'une ligne d'avis : lot technique / lot geo / panier (cle grise fixe + valeur). */
.avis-ligne-ids { display: flex; flex-direction: column; gap: 0.15rem; }
.avis-ligne-id { font-size: 1.3rem; color: #374151; }
.avis-ligne-id-k {
  display: inline-block;
  width: 13rem;
  color: #9ca3af;
  font-weight: 600;
  font-size: 1.15rem;
}
.avis-ligne-note {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.15rem;
  color: #6b7280;
  white-space: nowrap;
}
.avis-ligne-note-val { font-weight: 700; color: #374151; }
.avis-ligne-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem 1rem;
  margin-top: 0.2rem;
  font-size: 1.2rem;
  color: #9ca3af;
}
.avis-ligne-comment {
  margin: 0.6rem 0 0;
  font-size: 1.3rem;
  font-style: italic;
  color: #374151;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
.avis-ligne-action { margin-top: 0.9rem; }
.avis-groupe-head--skeleton {
  height: 5.4rem;
  border-radius: 0.8rem;
  background: linear-gradient(90deg, #f3f4f6 25%, #f9fafb 50%, #f3f4f6 75%);
  background-size: 200% 100%;
  animation: avis-card-sk 1.4s ease-in-out infinite;
}

/* Liste d'avis (profils / annuaire). */
.avis-list { display: flex; flex-direction: column; gap: 1.2rem; }

/* Grille 2 colonnes (profils acheteur + prestataire). */
.avis-list--grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.2rem;
  align-items: start;
}
/* En grille, l'espacement vient du \`gap\` : on annule le margin inter-cartes du mode liste. */
.avis-list--grid .avis-card + .avis-card { margin-top: 0; }

@media (max-width: 900px) {
  .avis-list--grid { grid-template-columns: 1fr; }
}
.avis-list-empty {
  font-size: 1.4rem;
  color: #9ca3af;
  text-align: center;
  padding: 3rem 0;
}
.avis-list-head {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
  color: #374151;
}
.avis-list-moyenne { font-weight: 700; }
.avis-list-count { color: #6b7280; }
`, "",{"version":3,"sources":["webpack://./src/composants/AvisPrestataire/AvisPrestataire.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,oBAAoB,kBAAkB,EAAE;AACxC;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA,6FAA6F;AAC7F;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA,uBAAuB,oBAAoB,EAAE,mBAAmB,EAAE;;AAElE,kGAAkG;AAClG;EACE,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA,gFAAgF;AAChF;EACE,8BAA8B;AAChC;AACA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA,mBAAmB,cAAc,EAAE;AACnC,4FAA4F;AAC5F;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA,0BAA0B,kBAAkB,EAAE;;AAE9C;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,gBAAgB,YAAY,EAAE,SAAO,EAAE;AACvC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,kBAAkB,gBAAgB,EAAE,cAAc,EAAE;AACpD,kBAAkB,cAAc,EAAE;;AAElC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC,mBAAmB,gBAAgB,EAAE;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,oBAAoB,cAAc,EAAE,gBAAgB,EAAE;;AAEtD;gCACgC;AAChC,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE;0BAC0B,cAAc,EAAE;AAC1C,yBAAyB,cAAc,EAAE;;AAEzC,iGAAiG;AACjG,kBAAkB,kBAAkB,EAAE;AACtC;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA,wBAAwB,oBAAoB,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAChF,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3E;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA,mEAAmE;AACnE;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;AACnD;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,yEAAyE;AACzE,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAEpE,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA,4BAA4B,aAAa,EAAE,qBAAqB,EAAE;AAClE,qBAAqB,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9E,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA,wBAAwB,gBAAgB,EAAE;AAC1C,sBAAsB,cAAc,EAAE;AACtC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;yGACyG;AACzG;EACE,WAAW;EACX,aAAa;EACb,mDAAmD;EACnD,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,wBAAwB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACxE,wBAAwB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7E;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,2FAA2F;AAC3F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA,wBAAwB,gBAAgB,EAAE,cAAc,EAAE;AAC1D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;AACA,uBAAuB,cAAc,EAAE,+BAA+B,EAAE;AACxE,4CAA4C,yBAAyB,EAAE;AACvE;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;2GAC2G;AAC3G;EACE,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA,mBAAmB,YAAY,EAAE;AACjC,6FAA6F;AAC7F,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACvE,iBAAiB,iBAAiB,EAAE,cAAc,EAAE;AACpD;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA,uBAAuB,gBAAgB,EAAE,cAAc,EAAE;AACzD;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,qBAAqB,kBAAkB,EAAE;AACzC;EACE,cAAc;EACd,qBAAqB;EACrB,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA,uCAAuC;AACvC,aAAa,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAEjE,wDAAwD;AACxD;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,kBAAkB;AACpB;AACA,6FAA6F;AAC7F,2CAA2C,aAAa,EAAE;;AAE1D;EACE,mBAAmB,0BAA0B,EAAE;AACjD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA,qBAAqB,gBAAgB,EAAE;AACvC,mBAAmB,cAAc,EAAE","sourcesContent":["/* Avis acheteur -> prestataire : carte (lecture seule) + editeur (onglet commande). */\n\n.avis-eval {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n.avis-eval-notice { margin: 0 0 1.2rem; }\n.avis-eval-empty {\n  font-size: 1.4rem;\n  color: #9ca3af;\n  text-align: center;\n  padding: 3rem 0;\n}\n/* Carte unique de l'avis (onglet Evaluation commande), meme look que les cartes du profil. */\n.avis-eval-card {\n  padding: 1.2rem 1.4rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n}\n.avis-eval-card-note { display: inline-flex; align-items: center; }\n\n/* ── Highlight de la section d'avis a remplir (carte editable) ; l'autre carte est attenuee. ── */\n.avis-eval-card--actionable {\n  background: rgba(249, 115, 22, 0.06);\n  border-left: 4px solid #f97316;\n}\n.avis-eval-card--given {\n  border-left: 4px solid #22c55e;\n}\n/* Etoiles vides en orange leger dans la carte a remplir, pour attirer l'oeil. */\n.avis-eval-card--actionable .star-rating-btn .star-rating-glyph:not(.is-filled) {\n  fill: rgba(249, 115, 22, 0.32);\n}\n/* Pastille \"Votre avis\" en tete de la carte editable. */\n.avis-eval-badge {\n  display: inline-block;\n  font-size: 1.15rem;\n  font-weight: 700;\n  padding: 0.25rem 0.85rem;\n  border-radius: 999px;\n  margin-bottom: 1rem;\n}\n.avis-eval-badge--todo {\n  background: rgba(249, 115, 22, 0.14);\n  color: #ea580c;\n}\n.avis-eval-badge--done {\n  background: rgba(34, 197, 94, 0.14);\n  color: #15803d;\n}\n.avis-ligne-date { color: #9ca3af; }\n/* En-tete de la carte d'avis : nom de la contrepartie + lot technique / lot geo / panier. */\n.avis-eval-head {\n  margin-bottom: 1rem;\n  padding-bottom: 0.9rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.avis-eval-name {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #374151;\n}\n\n/* Carte d'avis. */\n.avis-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  padding: 1.6rem 1.8rem;\n  background: #fff;\n}\n.avis-card + .avis-card { margin-top: 1.2rem; }\n\n.avis-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.2rem;\n}\n.avis-card-logo {\n  flex-shrink: 0;\n  width: 5.4rem;\n  height: 5.4rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  color: #9ca3af;\n  background: #f9fafb;\n  overflow: hidden;\n  text-align: center;\n}\n.avis-card-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.avis-card-id { min-width: 0; flex: 1; }\n.avis-card-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #374151;\n}\n.avis-card-num {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #6b7280;\n  margin-top: 0.1rem;\n}\n.avis-card-meta {\n  font-size: 1.2rem;\n  color: #9ca3af;\n  margin-top: 0.1rem;\n}\n.avis-card-rating {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n.avis-card-note { font-weight: 700; color: #374151; }\n.avis-card-date { color: #9ca3af; }\n\n.avis-card-comment {\n  margin: 1rem 0 0;\n  font-size: 1.35rem;\n  color: #374151;\n  line-height: 1.5;\n  font-style: italic;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Editeur (acheteur sur la commande). */\n.avis-card--edit { background: #fff; }\n.avis-eval-textarea {\n  width: 100%;\n  margin-top: 1.2rem;\n  min-height: 9rem;\n  padding: 1rem 1.2rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.7rem;\n  font-size: 1.35rem;\n  font-family: inherit;\n  color: #374151;\n  resize: vertical;\n}\n.avis-eval-textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n.avis-eval-foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.6rem;\n  font-size: 1.2rem;\n  color: #9ca3af;\n}\n.avis-eval-status { color: #16a34a; font-weight: 600; }\n\n/* Indicateur d'enregistrement (texte simple) : gris au repos, orange pendant (frappe/envoi),\n   vert une fois \"enregistre\". */\n.avis-eval-save { font-size: 1.2rem; font-weight: 600; color: #9ca3af; }\n.avis-eval-save--pending,\n.avis-eval-save--saving { color: #f97316; }\n.avis-eval-save--saved { color: #16a34a; }\n\n/* Bloc de notation editable : libelle + etoiles + valeur chiffree + aide (etoiles cliquables). */\n.avis-eval-rate { margin-top: 1.4rem; }\n.avis-eval-rate-label {\n  display: block;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n.avis-eval-rate-stars { display: inline-flex; align-items: center; gap: 0.9rem; }\n.avis-eval-rate-val { font-size: 1.6rem; font-weight: 700; color: #374151; }\n.avis-eval-rate-hint {\n  display: block;\n  margin-top: 0.5rem;\n  font-size: 1.2rem;\n  font-style: italic;\n  color: #9ca3af;\n}\n/* Barre d'actions de la carte (impression PDF) alignee a droite. */\n.avis-eval-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.4rem;\n  padding-top: 1.2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Skeleton de chargement (carte grisee animee). */\n.avis-card--skeleton {\n  height: 13rem;\n  background: linear-gradient(90deg, #f3f4f6 25%, #f9fafb 50%, #f3f4f6 75%);\n  background-size: 200% 100%;\n  animation: avis-card-sk 1.4s ease-in-out infinite;\n}\n@keyframes avis-card-sk {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n/* ── Avis GROUPES (par prestataire ou acheteur) : accordeon compact ── */\n.avis-groupes { display: flex; flex-direction: column; gap: 0.8rem; }\n\n/* Barre de recherche / filtre des avis (onglet Evaluations). */\n.avis-search-bar {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 0.4rem;\n}\n.avis-search-input {\n  flex: 1 1 22rem;\n  min-width: 16rem;\n  padding: 0.8rem 1.1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.7rem;\n  font-size: 1.35rem;\n  font-family: inherit;\n  color: #374151;\n}\n.avis-search-input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n.avis-filter-select {\n  padding: 0.8rem 1.1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.7rem;\n  font-size: 1.3rem;\n  font-family: inherit;\n  color: #374151;\n  background: #fff;\n  cursor: pointer;\n  max-width: 24rem;\n}\n.avis-filter-select:focus { outline: none; border-color: #f97316; }\n.avis-search-count { font-size: 1.25rem; color: #6b7280; white-space: nowrap; }\n/* Note globale (moyenne de tous les avis) en entete. */\n.avis-groupes-entete {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-bottom: 0.4rem;\n  font-size: 1.4rem;\n  color: #374151;\n}\n.avis-groupes-moyenne { font-weight: 700; }\n.avis-groupes-total { color: #6b7280; }\n.avis-groupe {\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  overflow: hidden;\n  background: #fff;\n}\n/* Grille alignee : logo | nom (1fr) | compteur (auto) | note (14rem) | chevron (2.2rem).\n   Memes colonnes que les lignes depliees -> etoiles + note alignees verticalement, sans chevauchement. */\n.avis-groupe-head {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 3.6rem 1fr auto 14rem 2.2rem;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.9rem 1.2rem;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n}\n.avis-groupe-head:hover { background: #f9fafb; }\n.avis-groupe-logo {\n  flex-shrink: 0;\n  width: 3.6rem;\n  height: 3.6rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #f9fafb;\n}\n.avis-groupe-logo img { width: 100%; height: 100%; object-fit: contain; }\n.avis-groupe-logo-txt { font-size: 1.1rem; font-weight: 700; color: #9ca3af; }\n.avis-groupe-nom {\n  min-width: 0;\n  font-size: 1.45rem;\n  font-weight: 700;\n  color: #374151;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/* Colonne note 14rem (etoiles 5x2rem + valeur), etoiles a gauche -> alignement vertical. */\n.avis-groupe-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 1.25rem;\n  color: #6b7280;\n  white-space: nowrap;\n}\n.avis-groupe-note-val { font-weight: 700; color: #374151; }\n.avis-groupe-count {\n  justify-self: end;\n  white-space: nowrap;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n  background: #f3f4f6;\n  padding: 0.2rem 0.7rem;\n  border-radius: 999px;\n}\n.avis-groupe-chevron { color: #9ca3af; transition: transform 0.2s ease; }\n.avis-groupe.is-open .avis-groupe-chevron { transform: rotate(180deg); }\n.avis-groupe-body {\n  padding: 1rem 1.2rem 1.2rem;\n  border-top: 1px solid #f3f4f6;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n/* Ligne depliee : MEMES colonnes que l'en-tete (spacer logo | contenu 1fr | note 14rem | chevron 2.2rem)\n   -> la note de chaque commande s'aligne pile sous la note globale du prestataire. Bordure grise simple. */\n.avis-ligne {\n  display: grid;\n  grid-template-columns: 1fr 14rem 2.2rem;\n  align-items: start;\n  gap: 1rem;\n  padding: 1rem 1.2rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.6rem;\n}\n.avis-ligne-main { min-width: 0; }\n/* En-tete d'une ligne d'avis : lot technique / lot geo / panier (cle grise fixe + valeur). */\n.avis-ligne-ids { display: flex; flex-direction: column; gap: 0.15rem; }\n.avis-ligne-id { font-size: 1.3rem; color: #374151; }\n.avis-ligne-id-k {\n  display: inline-block;\n  width: 13rem;\n  color: #9ca3af;\n  font-weight: 600;\n  font-size: 1.15rem;\n}\n.avis-ligne-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 1.15rem;\n  color: #6b7280;\n  white-space: nowrap;\n}\n.avis-ligne-note-val { font-weight: 700; color: #374151; }\n.avis-ligne-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.2rem 1rem;\n  margin-top: 0.2rem;\n  font-size: 1.2rem;\n  color: #9ca3af;\n}\n.avis-ligne-comment {\n  margin: 0.6rem 0 0;\n  font-size: 1.3rem;\n  font-style: italic;\n  color: #374151;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.avis-ligne-action { margin-top: 0.9rem; }\n.avis-groupe-head--skeleton {\n  height: 5.4rem;\n  border-radius: 0.8rem;\n  background: linear-gradient(90deg, #f3f4f6 25%, #f9fafb 50%, #f3f4f6 75%);\n  background-size: 200% 100%;\n  animation: avis-card-sk 1.4s ease-in-out infinite;\n}\n\n/* Liste d'avis (profils / annuaire). */\n.avis-list { display: flex; flex-direction: column; gap: 1.2rem; }\n\n/* Grille 2 colonnes (profils acheteur + prestataire). */\n.avis-list--grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.2rem;\n  align-items: start;\n}\n/* En grille, l'espacement vient du `gap` : on annule le margin inter-cartes du mode liste. */\n.avis-list--grid .avis-card + .avis-card { margin-top: 0; }\n\n@media (max-width: 900px) {\n  .avis-list--grid { grid-template-columns: 1fr; }\n}\n.avis-list-empty {\n  font-size: 1.4rem;\n  color: #9ca3af;\n  text-align: center;\n  padding: 3rem 0;\n}\n.avis-list-head {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  margin-bottom: 1.2rem;\n  font-size: 1.4rem;\n  color: #374151;\n}\n.avis-list-moyenne { font-weight: 700; }\n.avis-list-count { color: #6b7280; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
